export const devapis = {
    "getHeartbeat": {
        "method": "get",
        "url": "/v1/heartbeat"
    },
    "postLogin": {
        "method": "post",
        "url": "/v1/auth/login"
    },
    "postReset": {
        "method": "post",
        "url": "/v1/auth/reset"
    },
    "postRefresh": {
        "method": "post",
        "url": "/v1/auth/refresh"
    },
    "postLogout": {
        "method": "post",
        "url": "/v1/auth/logout"
    },
    "putPassword": {
        "method": "put",
        "url": "/v1/auth/password"
    },
    "getMe": {
        "method": "get",
        "url": "/v1/profile/me"
    },
    "postProfileCreate": {
        "method": "post",
        "url": "/v1/profile/create"
    },
    "getProfileAll": {
        "method": "get",
        "url": "/v1/profile/all"
    },
    "getProfile": {
        "method": "get",
        "url": "/v1/profile/{user_id}"
    },
    "putProfile": {
        "method": "put",
        "url": "/v1/profile/{user_id}"
    },
    "patchProfile": {
        "method": "patch",
        "url": "/v1/profile/{user_id}"
    },
    "deleteProfile": {
        "method": "delete",
        "url": "/v1/profile/{user_id}"
    },
    "postPersonal": {
        "method": "post",
        "url": "/v1/client/personal"
    },
    "getPersonal": {
        "method": "get",
        "url": "/v1/client/personal"
    },
    "putPersonal": {
        "method": "put",
        "url": "/v1/client/personal"
    },
    "postCompany": {
        "method": "post",
        "url": "/v1/client/company"
    },
    "getCompany": {
        "method": "get",
        "url": "/v1/client/company"
    },
    "putCompany": {
        "method": "put",
        "url": "/v1/client/company"
    },
    "postBusiness": {
        "method": "post",
        "url": "/v1/client/business"
    },
    "getBusiness": {
        "method": "get",
        "url": "/v1/client/business"
    },
    "putBusiness": {
        "method": "put",
        "url": "/v1/client/business/{director_id}"
    },
    "deleteBusiness": {
        "method": "delete",
        "url": "/v1/client/business/{director_id}"
    },
    "postDocuments": {
        "method": "post",
        "url": "/v1/client/documents"
    },
    "getDocumentsAll": {
        "method": "get",
        "url": "/v1/client/documents/all"
    },
    "getDocumentsMeta": {
        "method": "get",
        "url": "/v1/client/documents/meta"
    },
    "getDocuments": {
        "method": "get",
        "url": "/v1/client/documents/{attachment_id}"
    },
    "deleteDocuments": {
        "method": "delete",
        "url": "/v1/client/documents/{attachment_id}"
    },
    "postRequirement": {
        "method": "post",
        "url": "/v1/credit/requirement"
    },
    "getRequirement": {
        "method": "get",
        "url": "/v1/credit/requirement"
    },
    "putRequirement": {
        "method": "put",
        "url": "/v1/credit/requirement/{application_id}"
    },
    "postDocument": {
        "method": "post",
        "url": "/v1/credit/document"
    },
    "getDocument": {
        "method": "get",
        "url": "/v1/credit/document/{attachment_id}"
    },
    "deleteDocument": {
        "method": "delete",
        "url": "/v1/credit/document/{attachment_id}"
    },
    "getAllDocumentsByApplication":{
        "method":"get",
        "url":"/v1/credit/document/all/{application_id}"
    },
    "postCompanyDoc": {
        "method": "post",
        "url": "/v1/credit/{firm_type}/company-doc/{application_id}"
    },
    "getCompanyDoc": {
        "method": "get",
        "url": "/v1/credit/{firm_type}/company-doc/{application_id}"
    },
    "putCompanyDoc": {
        "method": "put",
        "url": "/v1/credit/{firm_type}/company-doc/{application_id}"
    },
    "postCompanyItr": {
        "method": "post",
        "url": "/v1/credit/{firm_type}/company-itr/{application_id}"
    },
    "getCompanyItr": {
        "method": "get",
        "url": "/v1/credit/{firm_type}/company-itr/{application_id}"
    },
    "putCompanyItr": {
        "method": "put",
        "url": "/v1/credit/{firm_type}/company-itr/{application_id}"
    },
    "postBankStatement": {
        "method": "post",
        "url": "/v1/credit/bank-statement/{application_id}"
    },
    "getBankStatement": {
        "method": "get",
        "url": "/v1/credit/bank-statement/{application_id}"
    },
    "putBankStatement": {
        "method": "put",
        "url": "/v1/credit/bank-statement/{bank_statement_id}"
    },
    "deleteBankStatement":{
        "method": "delete",
        "url": "/v1/credit/bank-statement/{bank_statement_id}"
    },
    "postBusinessSummary": {
        "method": "post",
        "url": "/v1/credit/business-summary/{application_id}"
    },
    "getBusinessSummary": {
        "method": "get",
        "url": "/v1/credit/business-summary/{application_id}"
    },
    "putBusinessSummary": {
        "method": "put",
        "url": "/v1/credit/business-summary/{application_id}"
    },
    "getBusinessSummaryTemplate":{
        "method": "get",
        "url": "/v1/credit/business-summary/template/{doc_type}"
    },
    "postBusinessSummaryTemplate":{
        "method": "post",
        "url": "/v1/credit/business-summary/template/{doc_type}"
    },
    "getPartnerAll":{
        "method": "get",
        "url": "/v1/client/partner/all"
    },
    "postPartnerDocument":{
        "method":"post",
        "url":"/v1/client/partner/documents"
    },
    "getPartnerDocument":{
        "method":"get",
        "url":"/v1/client/partner/documents"
    },
    "deletePartnerDocument":{
        "method":"delete",
        "url":"/v1/client/partner/documents/{attachment_id}"
    },
    "postPartnerByFirm":{
        "method":"post",
        "url":"/v1/client/partner/{firm_type}"
    },
    "postGstInfo": {
        "method": "post",
        "url": "/v1/credit/gst-info/{application_id}"
    },
    "getGstInfo": {
        "method": "get",
        "url": "/v1/credit/gst-info/{application_id}"
    },
    "putGstInfo": {
        "method": "put",
        "url": "/v1/credit/gst-info/{gst_info_id}"
    },
    "deleteGstInfo": {
        "method": "delete",
        "url": "/v1/credit/gst-info/{gst_info_id}"
    },

    "getSanctionLetter": {
        "method": "get",
        "url": "/v1/credit/sanction-letter/{application_id}"
    },
    "postSanctionLetter": {
        "method": "post",
        "url": "/v1/credit/sanction-letter/{application_id}"
    },
    "postLoanSanctionLetter": {
        "method": "post",
        "url": "/v1/credit/sanction-letter/loans/{sanction_letter_id}"
    },
    "deleteSanctionLetter": {
        "method": "delete",
        "url": "/v1/credit/sanction-letter/{sanction_letter_id}"
    },
    "putLoanSanctionLetter": {
        "method": "put",
        "url": "/v1/credit/sanction-letter/loans/{sanction_letter_id}/{loan_sanctioned_id}"
    },
    "putSanctionLetter": {
        "method": "put",
        "url": "/v1/credit/sanction-letter/{sanction_letter_id}"
    },
    "deleteLoanSanctionLetter": {
        "method": "delete",
        "url": "/v1/credit/sanction-letter/loans/{sanction_letter_id}/{loan_sanctioned_id}"
    },

    "getClientRating": {
        "method": "get",
        "url": "/v1/client/rating"
    },
    "postClientRating": {
        "method": "post",
        "url": "/v1/client/rating"
    },
    "putClientRating": {
        "method": "put",
        "url": "/v1/client/rating"
    }
    
};

export default devapis;
